@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.savedcards.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.savedcards.generated.resources/"

internal val Res.string.feature_savedcards_add: StringResource by lazy {
      StringResource("string:feature_savedcards_add", "feature_savedcards_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63, 34),
      ))
    }

internal val Res.string.feature_savedcards_add_cards: StringResource by lazy {
      StringResource("string:feature_savedcards_add_cards", "feature_savedcards_add_cards", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 52),
      ))
    }

internal val Res.string.feature_savedcards_all_fields_required: StringResource by lazy {
      StringResource("string:feature_savedcards_all_fields_required", "feature_savedcards_all_fields_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98, 74),
      ))
    }

internal val Res.string.feature_savedcards_cancel: StringResource by lazy {
      StringResource("string:feature_savedcards_cancel", "feature_savedcards_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173, 41),
      ))
    }

internal val Res.string.feature_savedcards_card_added_successfully: StringResource by lazy {
      StringResource("string:feature_savedcards_card_added_successfully", "feature_savedcards_card_added_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215, 82),
      ))
    }

internal val Res.string.feature_savedcards_card_deleted_successfully: StringResource by lazy {
      StringResource("string:feature_savedcards_card_deleted_successfully", "feature_savedcards_card_deleted_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298, 88),
      ))
    }

internal val Res.string.feature_savedcards_card_number: StringResource by lazy {
      StringResource("string:feature_savedcards_card_number", "feature_savedcards_card_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 387, 58),
      ))
    }

internal val Res.string.feature_savedcards_card_updated_successfully: StringResource by lazy {
      StringResource("string:feature_savedcards_card_updated_successfully", "feature_savedcards_card_updated_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 446, 88),
      ))
    }

internal val Res.string.feature_savedcards_close: StringResource by lazy {
      StringResource("string:feature_savedcards_close", "feature_savedcards_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 535, 40),
      ))
    }

internal val Res.string.feature_savedcards_confirm_delete_card: StringResource by lazy {
      StringResource("string:feature_savedcards_confirm_delete_card", "feature_savedcards_confirm_delete_card", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 576, 102),
      ))
    }

internal val Res.string.feature_savedcards_credit_card_number: StringResource by lazy {
      StringResource("string:feature_savedcards_credit_card_number", "feature_savedcards_credit_card_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 679, 69),
      ))
    }

internal val Res.string.feature_savedcards_cvv: StringResource by lazy {
      StringResource("string:feature_savedcards_cvv", "feature_savedcards_cvv", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 833, 34),
      ))
    }

internal val Res.string.feature_savedcards_cvv_length_error: StringResource by lazy {
      StringResource("string:feature_savedcards_cvv_length_error", "feature_savedcards_cvv_length_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 749, 83),
      ))
    }

internal val Res.string.feature_savedcards_delete_card: StringResource by lazy {
      StringResource("string:feature_savedcards_delete_card", "feature_savedcards_delete_card", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 868, 54),
      ))
    }

internal val Res.string.feature_savedcards_edit_card: StringResource by lazy {
      StringResource("string:feature_savedcards_edit_card", "feature_savedcards_edit_card", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 923, 48),
      ))
    }

internal val Res.string.feature_savedcards_edit_clicked: StringResource by lazy {
      StringResource("string:feature_savedcards_edit_clicked", "feature_savedcards_edit_clicked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 55),
      ))
    }

internal val Res.string.feature_savedcards_error_oops: StringResource by lazy {
      StringResource("string:feature_savedcards_error_oops", "feature_savedcards_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1028, 45),
      ))
    }

internal val Res.string.feature_savedcards_expiry_date: StringResource by lazy {
      StringResource("string:feature_savedcards_expiry_date", "feature_savedcards_expiry_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1166, 54),
      ))
    }

internal val Res.string.feature_savedcards_expiry_date_length_error: StringResource by lazy {
      StringResource("string:feature_savedcards_expiry_date_length_error", "feature_savedcards_expiry_date_length_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1074, 91),
      ))
    }

internal val Res.string.feature_savedcards_first_name: StringResource by lazy {
      StringResource("string:feature_savedcards_first_name", "feature_savedcards_first_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1221, 53),
      ))
    }

internal val Res.string.feature_savedcards_invalid_credit_card: StringResource by lazy {
      StringResource("string:feature_savedcards_invalid_credit_card", "feature_savedcards_invalid_credit_card", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1275, 82),
      ))
    }

internal val Res.string.feature_savedcards_invalid_expiry_date: StringResource by lazy {
      StringResource("string:feature_savedcards_invalid_expiry_date", "feature_savedcards_invalid_expiry_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1358, 74),
      ))
    }

internal val Res.string.feature_savedcards_last_name: StringResource by lazy {
      StringResource("string:feature_savedcards_last_name", "feature_savedcards_last_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1433, 48),
      ))
    }

internal val Res.string.feature_savedcards_loading: StringResource by lazy {
      StringResource("string:feature_savedcards_loading", "feature_savedcards_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1482, 46),
      ))
    }

internal val Res.string.feature_savedcards_mm_yy: StringResource by lazy {
      StringResource("string:feature_savedcards_mm_yy", "feature_savedcards_mm_yy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1529, 40),
      ))
    }

internal val Res.string.feature_savedcards_no: StringResource by lazy {
      StringResource("string:feature_savedcards_no", "feature_savedcards_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1570, 33),
      ))
    }

internal val Res.string.feature_savedcards_search: StringResource by lazy {
      StringResource("string:feature_savedcards_search", "feature_savedcards_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1604, 41),
      ))
    }

internal val Res.string.feature_savedcards_subtitle: StringResource by lazy {
      StringResource("string:feature_savedcards_subtitle", "feature_savedcards_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1646, 99),
      ))
    }

internal val Res.string.feature_savedcards_yes: StringResource by lazy {
      StringResource("string:feature_savedcards_yes", "feature_savedcards_yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1746, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_savedcards_add", Res.string.feature_savedcards_add)
  map.put("feature_savedcards_add_cards", Res.string.feature_savedcards_add_cards)
  map.put("feature_savedcards_all_fields_required", Res.string.feature_savedcards_all_fields_required)
  map.put("feature_savedcards_cancel", Res.string.feature_savedcards_cancel)
  map.put("feature_savedcards_card_added_successfully", Res.string.feature_savedcards_card_added_successfully)
  map.put("feature_savedcards_card_deleted_successfully", Res.string.feature_savedcards_card_deleted_successfully)
  map.put("feature_savedcards_card_number", Res.string.feature_savedcards_card_number)
  map.put("feature_savedcards_card_updated_successfully", Res.string.feature_savedcards_card_updated_successfully)
  map.put("feature_savedcards_close", Res.string.feature_savedcards_close)
  map.put("feature_savedcards_confirm_delete_card", Res.string.feature_savedcards_confirm_delete_card)
  map.put("feature_savedcards_credit_card_number", Res.string.feature_savedcards_credit_card_number)
  map.put("feature_savedcards_cvv", Res.string.feature_savedcards_cvv)
  map.put("feature_savedcards_cvv_length_error", Res.string.feature_savedcards_cvv_length_error)
  map.put("feature_savedcards_delete_card", Res.string.feature_savedcards_delete_card)
  map.put("feature_savedcards_edit_card", Res.string.feature_savedcards_edit_card)
  map.put("feature_savedcards_edit_clicked", Res.string.feature_savedcards_edit_clicked)
  map.put("feature_savedcards_error_oops", Res.string.feature_savedcards_error_oops)
  map.put("feature_savedcards_expiry_date", Res.string.feature_savedcards_expiry_date)
  map.put("feature_savedcards_expiry_date_length_error", Res.string.feature_savedcards_expiry_date_length_error)
  map.put("feature_savedcards_first_name", Res.string.feature_savedcards_first_name)
  map.put("feature_savedcards_invalid_credit_card", Res.string.feature_savedcards_invalid_credit_card)
  map.put("feature_savedcards_invalid_expiry_date", Res.string.feature_savedcards_invalid_expiry_date)
  map.put("feature_savedcards_last_name", Res.string.feature_savedcards_last_name)
  map.put("feature_savedcards_loading", Res.string.feature_savedcards_loading)
  map.put("feature_savedcards_mm_yy", Res.string.feature_savedcards_mm_yy)
  map.put("feature_savedcards_no", Res.string.feature_savedcards_no)
  map.put("feature_savedcards_search", Res.string.feature_savedcards_search)
  map.put("feature_savedcards_subtitle", Res.string.feature_savedcards_subtitle)
  map.put("feature_savedcards_yes", Res.string.feature_savedcards_yes)
}
